import { DispatcherEvent } from '@carvana/merch-native';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useIsNative } from '~/context/common/DeviceContext';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import { navPerformanceNow } from '~/utilities/navigationTiming';
import sendMessageToNative from './sendMessageToNative';

export default function usePageReadyDispatcher(shouldSend: boolean) {
  const isNative = useIsNative();
  const { creditStatus } = useFinancingContext();

  const shouldSendPageReady = shouldSend && isNative;

  useEffectOnce(
    () => {
      sendMessageToNative(DispatcherEvent.PageReady, {
        hasValidSoftPull: !!creditStatus?.hasValidSoftPull,
        navigationToNowMs: navPerformanceNow()
      });
    },
    [creditStatus?.hasValidSoftPull],
    shouldSendPageReady
  );
}
